import { render, staticRenderFns } from "./TableSortMixin.vue?vue&type=template&id=6354856c&"
import script from "./TableSortMixin.vue?vue&type=script&lang=ts&"
export * from "./TableSortMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports